import { render } from "./SortList.vue?vue&type=template&id=4592d9da"
import script from "./SortList.vue?vue&type=script&lang=js"
export * from "./SortList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__